__turbopack_context__.v({
  "readout": "FlightHud-module__axWx0q__readout",
});
